var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import MobileSubmenu from './mobile-submenu';
import { Background, Container, LinkItem as Link, List, ListItem, SubmenuToggler, MobileWidgets, MobileWidgetWrapper, MobileWidgetItem, MobileWidgetIcon } from './MobileMenu.styles';

var MobileMenu = function MobileMenu(_a) {
  var navigationLinks = _a.navigationLinks,
      secondaryNavLinks = _a.secondaryNavLinks,
      widgetActions = _a.widgetActions,
      linkComponent = _a.linkComponent,
      state = __rest(_a, ["navigationLinks", "secondaryNavLinks", "widgetActions", "linkComponent"]);

  var isMenuOpen = state.isMenuOpen;
  return /*#__PURE__*/React.createElement(Container, {
    open: isMenuOpen
  }, isMenuOpen && /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("style", {
    type: 'text/css'
  }, "\n              body {\n                overflow: hidden;\n              }\n          ")), /*#__PURE__*/React.createElement(Background, {
    open: isMenuOpen,
    "data-test": 'header-mobile-menu'
  }, /*#__PURE__*/React.createElement(MobileWidgets, null, secondaryNavLinks.map(function (secLink) {
    return /*#__PURE__*/React.createElement(MobileWidgetWrapper, {
      key: secLink.id
    }, /*#__PURE__*/React.createElement(MobileWidgetItem, {
      tabIndex: 0,
      "data-test": secLink.submenuItems && secLink.submenuItems.length ? 'header-mobile-sec-menu-widget' : 'header-mobile-menu-widget',
      onClick: function onClick() {
        if (secLink.submenuItems && secLink.submenuItems.length) {
          state.setHeaderSubmenu("mob-sec-" + secLink.id);
          return;
        }

        if (!widgetActions[secLink.handlerId]) {
          throw new Error('Widget handler id doesnt match any action creator');
        }

        widgetActions[secLink.handlerId]();
      },
      "data-ga-trigger": true
    }, /*#__PURE__*/React.createElement(MobileWidgetIcon, {
      url: secLink.icon.url,
      role: 'img',
      "aria-label": secLink.icon.alternativeText || ''
    }), secLink.label));
  })), /*#__PURE__*/React.createElement(List, null, navigationLinks.map(function (_a) {
    var id = _a.id,
        label = _a.label,
        link = _a.link,
        submenuRows = _a.submenuRows;
    return /*#__PURE__*/React.createElement(Fragment, {
      key: id
    }, /*#__PURE__*/React.createElement(ListItem, null, submenuRows && submenuRows.length > 0 ? /*#__PURE__*/React.createElement(SubmenuToggler, {
      tabIndex: 0,
      "data-test": 'header-mobile-submenu-toggler',
      onClick: function onClick() {
        return state.setMobileSubmenuId(id);
      }
    }, label) : /*#__PURE__*/React.createElement(Link, {
      href: link,
      as: linkComponent,
      onClick: function onClick() {
        return state.setMenuOpen(false);
      }
    }, label)), submenuRows && submenuRows.length > 0 && /*#__PURE__*/React.createElement(MobileSubmenu, __assign({
      id: id,
      parentLabel: label,
      submenuRows: submenuRows,
      linkComponent: linkComponent
    }, state
    /* eslint-disable-line react/jsx-props-no-spreading, max-len */
    )));
  }))));
};

export default MobileMenu;